import { atom } from 'recoil';

export const multipleReportsPopoverAtom = atom<number | null>({
	key: 'multipleReportsPopover',
	default: null,
});
